// extracted by mini-css-extract-plugin
export default {"filepickerContainer":"ProjectPicker_filepickerContainer__IWZ0x","projectsContainer":"ProjectPicker_projectsContainer__lR7SI","overlay":"ProjectPicker_overlay__R0211"};